import { render, staticRenderFns } from "./QuotationDetails.vue?vue&type=template&id=6558cec6&scoped=true&"
import script from "./QuotationDetails.vue?vue&type=script&lang=js&"
export * from "./QuotationDetails.vue?vue&type=script&lang=js&"
import style0 from "./QuotationDetails.vue?vue&type=style&index=0&id=6558cec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6558cec6",
  null
  
)

export default component.exports